import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
// components
import Shell from "../../components/allies/Shell";
import Guests from "../../components/allies/Guests";
// context
import { useAlly } from "../../context/ally";
// modals
import TripInfo from "../../components/allies/modals/TripInfo";
import Summary from "../../components/allies/modals/Summary";
import EditReservation from "../../components/allies/modals/EditReservation";
import CreateGroup from "../../components/allies/modals/CreateGroup";
import AddReservationGroup from "../../components/allies/modals/AddReservationGroup";
import TicketPaymentGroup from "../../components/allies/modals/TicketPaymentGroup";
import ConfirmBoucher from "../../components/allies/modals/ConfirmBoucher";
import ConfirmDeleteReservation from "../../components/allies/modals/ConfirmDeleteReservation";
import Passengers from "../../components/allies/modals/Passengers";

export default function HomeAlly() {
    const {
        user,
        tripInfo,
        isCreateGroupModalOpen,
        newGroup,
        isTicketPaymentGroupModalOpen,
        isConfirmBoucherModalOpen,
        isSummaryModalOpen,
        editReservationId,
        confirmDeleteReservationId,
        isPassengersModalOpen,
    } = useAlly()
    const router = useNavigate()
    useEffect(() => {
        if (!user) return router('/ally/access')
    }, [user, router])
    return (
        <Shell active="guests">
            <Guests/>
            {
                tripInfo &&
                <TripInfo/>
            }
            {/* Agregar huéspedes, paso 1 → 2 → 3 → voucher. El paso 1 se cierra solo cuando ya hay
                pasajeros creados (newGroup), que es lo que abre el paso 2. */}
            {
                isCreateGroupModalOpen && newGroup.length === 0 &&
                <CreateGroup/>
            }
            {
                newGroup.length > 0 &&
                <AddReservationGroup/>
            }
            {
                isTicketPaymentGroupModalOpen &&
                <TicketPaymentGroup/>
            }
            {
                isConfirmBoucherModalOpen &&
                <ConfirmBoucher/>
            }
            {
                isSummaryModalOpen &&
                <Summary/>
            }
            {
                editReservationId &&
                <EditReservation/>
            }
            {
                confirmDeleteReservationId &&
                <ConfirmDeleteReservation/>
            }
            {
                isPassengersModalOpen &&
                <Passengers/>
            }
        </Shell>
    )
}
